/**
 * Created by Rodrigo Quesada on 04/01/17.
 */
export class Address {
    public address1?: string;
    public address2?: string;
    public postalCode?: string;
    public city?: string;
    public stateOrProvince?: string;
    public country?: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/common/values/address.class.ts